import { observer } from 'mobx-react';
import * as style from './UserMessage.module.less';
import { SideChatMessage } from '@assets/model/SideChatStore';

interface UserMessageProps {
    message: SideChatMessage;
}

const UserMessage = observer((p: UserMessageProps) => {
    const { message: m } = p;

    return <div className={style.userMessage}>{m.content}</div>;
});

export default UserMessage;
